module.exports = __webpack_public_path__ + "static/media/provider_hover.c65a7dc8.svg";